import React from "react";
var SupportPopup = function () {
    return (React.createElement("div", { className: "sales-support-popup" },
        React.createElement("div", { className: "d-flex align-items-center justify-content-between" },
            React.createElement("div", { className: "DMSansNormal_12_400 txt_blackOne1" }, "Client Support \u00A0\u00A0\u00A0"),
            React.createElement("div", { className: "DMSansMedium_12_500 txt-midnight-blue hand_cursor" }, "18001023335"))));
};
export default SupportPopup;
